import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Box } from '@change-corgi/design-system-legacy/layout';

export function ErrorState(): JSX.Element {
	return (
		<Box py={24}>
			<InlineMessage size="large" variant="error">
				<Translate value="fe.errors.generic_try_again" />
			</InlineMessage>
		</Box>
	);
}
